import React from 'react'
import PropTypes from 'prop-types'
import { CToast, CToastHeader, CToastBody, CToastClose } from '@coreui/react'

const SuccessNotification = ({ tittle, message }) => {
  return (
    <CToast
      autohide={true}
      color="success"
      className="align-items-center"
      title="SuccessNotification"
    >
      <CToastHeader className="text-white">
        <strong className="me-auto">{tittle}</strong>
        <CToastClose className="me-2 m-auto" white />
      </CToastHeader>
      <div className="d-flex">
        <CToastBody className="text-white">{message}</CToastBody>
      </div>
    </CToast>
  )
}

SuccessNotification.propTypes = {
  tittle: PropTypes.string,
  message: PropTypes.string,
}

export default SuccessNotification
